module.exports = __webpack_public_path__ + "static/img/4.d6fcaa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/2/4.png
// module id = NiTF
// module chunks = 1